<template>
    <div>
        <page-title-farmasi heading="Detail Farmasi" :breadcrumb="[
            {
                label: 'Farmasi',
                link: '/klinik/farmasi'
            },
            {
                label: 'Detail Farmasi',
                active: true
            }
        ]">
            <template #backBtnSlot>
                <b-col sm="12" class="mb-4">
                    <router-link to="/klinik/farmasi">
                        <font-awesome-icon icon="chevron-left" size="lg" />

                    </router-link>
                </b-col>

            </template>
            <template #exampleSlot>
                <b-col sm="12">
                    <div class="p-4" style="width: 100%; background-color: #c1e4fb;">
                        <b-row>
                            <b-col sm="12" md="6" lg="6">
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Nama pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.nama }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Nama dokter</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.dokter }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Poli</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.poliklinik }}</p>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Tanggal Konsultasi</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.tanggal_konsultasi }}</p>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="12" md="6" lg="6">
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">No Invoice</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.no_invoice }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Kategori pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">{{ pasienInfo.kategori }}</p>
                                    </div>

                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">tinggi badan pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <p class="text-capitalize">
                                            <template v-if="dataLoaded">
                                                {{ !pasienInfo.tinggi_badan || pasienInfo.tinggi_badan == 0 ? '-': pasienInfo.tinggi_badan + ' cm' }}
                                            </template>
                                        </p>
                                    </div>
                                </div>
                                <div class="farmasi-info">
                                    <div>
                                        <p class="font-weight-bold text-capitalize">Berat badan pasien</p>
                                    </div>
                                    <div class="px-2">
                                        :
                                    </div>
                                    <div>
                                        <template v-if="dataLoaded">
                                            <p class="text-capitalize">{{ !pasienInfo.berat_badan || pasienInfo.berat_badan == 0 ? '-': pasienInfo.berat_badan + ' kg' }}</p>
                                        </template>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </template>
        </page-title-farmasi>
        <div v-if="!isCetakLabel" class="container-fluid">
            <div class="card card-box  px-4">
                <b-row class="mb-4">
                    <b-col sm="12" md="6">
                        <div class="d-flex align-items-center mb-4 flex-wrap">
                            <div class="pr-0 pr-md-5 pl-md-3 pl-0" style="flex: 1;">
                                <step-progress :steps="mySteps" :current-step="currentStep" :line-thickness="6"
                                    :active-thickness="2" :passive-thickness="2" icon-class="fas fa-check"
                                    active-color="#0290ff"></step-progress>
                            </div>
                            <div style="flex-basis: 20%;">
                                <b-button v-if="currentStep < 1" @click="nextStep" variant="info" class="rounded"
                                    style="background-color: #0290ff;">Proses</b-button>
                                <b-button v-else-if="currentStep < 2" @click="nextStep"
                                    class="rounded confirm-submit cfms">Selesai</b-button>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="12" md="6" class="d-flex justify-content-end align-items-center mb-4">
                        <b-button @click="toggleModalCetakLabel" variant="primary" class="rounded">Cetak Label</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-row class="mb-3">
                            <b-col sm="3" class="text-capitalize"><strong>Nama Obat & BHP</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>QTY</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>Satuan</strong></b-col>
                            <b-col sm="2" class="text-capitalize"><strong>Aturan Pakai</strong></b-col>
                            <b-col sm="3" class="text-capitalize"><strong>Catatan</strong></b-col>
                        </b-row>
                        <b-row class="mb-3" v-for="(item) in pasienInfo.detail" :key="item.id">
                            <b-col sm="3">
                                <b-form-input :value="item.nama_layanan" disabled></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <b-form-input :value="item.quantity" disabled></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <b-form-input :value="!item.satuan ? '' : item.satuan.name" disabled></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <b-form-input :value="item.aturan_pakai" disabled></b-form-input>
                            </b-col>
                            <b-col sm="3">
                                <b-form-input :value="item.keterangan" disabled></b-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </div>
        <CetakLabel v-else :pasienInfo="pasienInfo" :selectedObat="selectedItems" @toggle="toggleViewCetakLabel">
        </CetakLabel>
        <!-- start: modal cetak label -->
        <b-modal title="Cetak Label" size="sm" ref="modal-cetak-label" button-size="sm" :centered="true"
            :no-close-on-backdrop="true">
            <p>Pilih obat untuk dicetak label</p>
            <b-form-checkbox v-model="checkboxAll">Check Semua</b-form-checkbox>
            <div v-for="(item, index) in checkboxItems" :key="item.id">
                <b-form-checkbox v-model="selectedItems[index]" :value="item">{{ item.nama_layanan }}</b-form-checkbox>
            </div>
            <template #modal-footer>
                <b-button variant="danger" size="sm" @click="toggleModalCetakLabel">Batal</b-button>
                <b-button variant="success" size="sm" @click="clickSerahkan">Serahkan</b-button>
            </template>
        </b-modal>
        <!-- end: modal cetak label -->
    </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

library.add(faCheck, faChevronLeft)

import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

import CetakLabel from './CetakLabel.vue'

export default {
    components: {
        'step-progress': StepProgress,
        CetakLabel
    },
    data() {
        return {
            mySteps: ['Proses Obat', 'Obat Siap', 'Serahkan Obat'],
            currentStep: -1,
            checkboxAll: false,
            checkboxItems: [],
            selectedItems: [],
            initSelectedItems: [],
            pasienInfo: {},
            isCetakLabel: false,
            dataLoaded: false
        }
    },
    watch: {
        // Watch for changes in 'selectAll'
        checkboxAll: function (newValue) {
            if (newValue) {
                // If 'selectAll' is true, select all items
                this.selectedItems = [...this.checkboxItems];
            } else {
                // If 'selectAll' is false, deselect all items
                const test = []
                this.selectedItems = test
            }
        },

        selectedItems(newValue) {
            // Check if all items are selected
            const allSelected = this.checkboxItems.every((item) => newValue.includes(item));

            // Update the 'selectAll' checkbox accordingly
            this.checkboxAll = allSelected;
        },
    },
    methods: {
        nextStep() {
            if (this.currentStep === 1) {
                this.$swal({
                    allowOutsideClick: false,
                    type: "warning",
                    title: 'Proses Obat Selesai',
                    text: 'Pastikan seluruh obat sudah diterima pasien',
                    confirmButtonColor: "#1791EE",
                    confirmButtonText: "Ya",
                    cancelButtonText: "Tidak",
                    showCancelButton: true,
                }).then((res) => {
                    if (res.value == true) {
                        this.currentStep = 2
                        this.prosesFarmasi(this.currentStep)
                        //redirect to list
                        this.redirectToList();
                    } else {
                        this.currentStep = this.currentStep
                    }
                })
            } else {
                this.currentStep++
                this.prosesFarmasi(this.currentStep)
            }

        },
        async prosesFarmasi(status) {
            let id_pasien = this.$router.currentRoute.params.id;
            try {
                const payload = {
                    status: status + 1 // -1 -> 0 example
                }
                let res = await this.$axios.post(`farmasi/proses_obat/${id_pasien}`, payload)
                const { success, data } = res.data

                if (success) {
                    this.currentStep = data.status_bhp - 1 // 2 -> 1 example
                }
            } catch (error) {
                // console.log(error);
            }
        },
        redirectToList() {
            this.$router.push('/klinik/farmasi');
        },
        toggleModalCetakLabel() {
            this.$refs["modal-cetak-label"].toggle("#toggle-btn");
        },
        clickSerahkan() {
            const allNull = this.selectedItems.every((element) => element === null);

            if (allNull) {
                this.$swal({
                    allowOutsideClick: false,
                    type: "warning",
                    text: 'Silakan pilih minimal 1 obat untuk dicetak label',
                })
            } else {
                // this.toggleViewCetakLabel()
                this.toggleModalCetakLabel()

                this.createLabel()
               
            }
        },
        async getDetailFarmasi() {
            let id_pasien = this.$router.currentRoute.params.id;
            try {
                let res = await this.$axios.get(`farmasi/${id_pasien}`)
                const { success, data } = res.data

                if (success) {
                    this.pasienInfo = data
                    this.currentStep = +data.status_bhp - 1 // 0 -> -1 example
                    this.checkboxItems = data.detail
                    this.dataLoaded = true;
                }
            } catch (error) {
                // console.log(error);
            }
        },
        toggleViewCetakLabel() {
            this.isCetakLabel = !this.isCetakLabel
        },

        async createLabel() {
            try {
                const detail_obat = []

                this.selectedItems.forEach(item => {
                    detail_obat.push({
                        id: item.id
                    })
                })

                let payload = {
                    nama_pasien: this.pasienInfo.nama,
                    tanggal_lahir: moment(this.pasienInfo.tanggal_lahir).format('DD/MM/YYYY'),
                    no_invoice: this.pasienInfo.no_invoice,
                    tanggal_konsul: moment(this.pasienInfo.tanggal_konsultasi).format('DD/MM/YYYY'),
                    detail_obat: detail_obat
                }

                let res = await this.$axios.post(`farmasi/cetak-label`, payload)
                const { success, url } = res.data

                if (success) {
                    window.open(url, '_blank')
                    window.location.reload();

                }

            } catch (error) {
                this.$swal({
                    allowOutsideClick: false,
                    type: "error",
                    text: error,
                })
            }
        }
    },

    mounted() {
        this.getDetailFarmasi()
    },
}
</script>

<style lang="scss" scoped>
.farmasi-info {
    display: flex;

    &>div {
        flex: 1;
        text-align: left;

        &:nth-child(2) {
            flex: 0
        }

        &:last-child {
            flex-basis: 0%;
            text-align: left;
        }
    }
}

::v-deep .step-progress__bar {
    margin-bottom: 0;
}

::v-deep .step-progress__step {

    span {
        font-size: 25px;
    }

    &:after {
        width: 50px;
        height: 50px;
    }

    &--valid {
        span {
            opacity: 1;
            color: white;
            transform: none;
            font-size: 25px;
        }
    }

    &--active {
        span {
            opacity: 1;
            color: white;
            transform: none;
            font-size: 25px;
        }

        &:after {
            color: white;
            background-color: #0290ff;
        }
    }
}

::v-deep .step-progress__step-label {
    top: calc(100% + 15px);
    font-size: 14px;
}

.cfms {
    color: white;
}

.cfms::hover {
    color: "#1791EE";
}
</style>